// import { ChevronDoubleDownIcon } from '@heroicons/react/16/solid'
import { Link } from '@tanstack/react-router'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { useHomeStrings } from '../../../i18n'

export default function Hero() {
  const t = useHomeStrings().hero

  return (
<div className="relative bg-background overflow-hidden">
      <div className="relative md:flex gap-8">
        <div className="flex flex-col w-full justify-center items-center">
          <h1 className="text-4xl tracking-tight font-extrabold text-foreground sm:text-5xl md:text-5xl text-center">
            <span className="block">{t.titleLine1}</span>
            <span className="block text-accent">{t.titleLine2}</span>
          </h1>
          <p className="mt-3 max-w-md text-base text-muted-foreground/90 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl text-center">
            {t.lead}
          </p>
          <div className="mt-6 max-w-md sm:flex md:mt-8 space-x-4 flex gap-4 justify-center">
            <div className="rounded-lg shadow-sm">
              <Link
                to="/sign-up"
                className="w-full flex items-center justify-center px-4 py-3 border border-transparent text-base font-medium rounded-lg text-primary-foreground bg-primary hover:bg-primary-hover md:py-4 md:text-lg md:px-6 transition-all duration-200 ease-in-out"
              >
                {t.ctaSignUp}
              </Link>
            </div>
            <div className="rounded-lg shadow-sm">
              <Link
                to="#file-upload"
                className="w-full flex items-center justify-center px-4 py-3 border border-accent text-base font-medium rounded-lg text-accent hover:bg-accent/10 md:py-4 md:text-lg md:px-6 transition-all duration-200 ease-in-out"
              >
                {t.ctaTry}
                <ChevronDownIcon className="ml-2 -mr-1 h-5 w-5" aria-hidden="true" />
              </Link>
            </div>
          </div>
          <p className="mt-4 text-sm text-muted-foreground/80 text-center">
            {t.trust}
          </p>
        </div>
      </div>
    </div>
  )
}
